export default "__VITE_ASSET__06755095__"